import {
  EnrollmentStatus,
  IEnrollment
} from "@wingspanhq/benefits/dist/src/lib/interfaces/enrollment";
import {
  INextgenSubscription,
  ISubscription
} from "@wingspanhq/users/dist/lib/interfaces";
import { selectorHasOnlyEndedSubscriptions } from "../../../shared/selectors/selectorHasOnlyEndedSubscriptions";

export interface ShouldShowMemberAndGroupInfoInput {
  helperHideMemberAndGroupInfo?: boolean;
  subscription?: ISubscription;
  nextGenSubscriptions?: INextgenSubscription[];
  enrollment?: IEnrollment;
  /**
   * Pass false while the subscription queries are still loading or
   * errored — an unsettled query must never hide the IDs (fail-open),
   * because the missing data could contain a live subscription.
   */
  areSubscriptionQueriesSettled?: boolean;
  now?: Date;
}

// Hide the IDs only on explicit terminal/inactive states: every
// subscription record ended, or enrollment explicitly Paused/Disabled.
// A missing enrollment status does NOT hide, so legacy enrollment
// records are unaffected.
export const selectorShouldShowMemberAndGroupInfo = ({
  helperHideMemberAndGroupInfo,
  subscription,
  nextGenSubscriptions,
  enrollment,
  areSubscriptionQueriesSettled = true,
  now
}: ShouldShowMemberAndGroupInfoInput): boolean => {
  const enrollmentStatus = enrollment?.wingspanBenefits?.status;
  const isEnrollmentExplicitlyInactive =
    enrollmentStatus === EnrollmentStatus.Paused ||
    enrollmentStatus === EnrollmentStatus.Disabled;

  const hasOnlyEndedSubscriptions =
    areSubscriptionQueriesSettled &&
    selectorHasOnlyEndedSubscriptions({
      subscription,
      nextGenSubscriptions,
      now
    });

  return (
    !helperHideMemberAndGroupInfo &&
    !hasOnlyEndedSubscriptions &&
    !isEnrollmentExplicitlyInactive
  );
};
